/**
 * @generated SignedSource<<93977e077f5fd5d52cee757f1819f1f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetIssueOverviewQuery$variables = {
  id: string;
};
export type WidgetIssueOverviewQuery$data = {
  readonly widgetIssueOverview: {
    readonly id: string;
    readonly title: string;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetIssueOverviewData_widgetIssueOverview">;
  } | null;
};
export type WidgetIssueOverviewQuery = {
  response: WidgetIssueOverviewQuery$data;
  variables: WidgetIssueOverviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = [
  (v2/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = [
  (v6/*: any*/),
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetIssueOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WidgetIssueOverview",
        "kind": "LinkedField",
        "name": "widgetIssueOverview",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WidgetIssueOverviewData_widgetIssueOverview"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WidgetIssueOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WidgetIssueOverview",
        "kind": "LinkedField",
        "name": "widgetIssueOverview",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "overviewSize",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "teams",
            "plural": true,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issues",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "task",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Routine",
                    "kind": "LinkedField",
                    "name": "routine",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "ownerTeam",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "taskExecution",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineSectionVersion",
                    "kind": "LinkedField",
                    "name": "sectionVersion",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ordinal",
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoutineSection",
                        "kind": "LinkedField",
                        "name": "section",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Team",
                            "kind": "LinkedField",
                            "name": "assignedTeam",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "resolved",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "images",
                "plural": true,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "IssueAssignedUser",
                "kind": "LinkedField",
                "name": "assignedUsers",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cdbae557b70002a921c6cce983b9498e",
    "id": null,
    "metadata": {},
    "name": "WidgetIssueOverviewQuery",
    "operationKind": "query",
    "text": "query WidgetIssueOverviewQuery(\n  $id: ID!\n) {\n  widgetIssueOverview(id: $id) {\n    id\n    title\n    ...WidgetIssueOverviewData_widgetIssueOverview\n  }\n}\n\nfragment WidgetIssueOverviewData_widgetIssueOverview on WidgetIssueOverview {\n  id\n  title\n  overviewSize\n  teams {\n    id\n  }\n  issues {\n    id\n    ...WidgetIssueOverviewList_issue\n  }\n}\n\nfragment WidgetIssueOverviewIssueItemAssignees_issue on Issue {\n  assignedUsers {\n    user {\n      name\n      id\n    }\n    id\n  }\n}\n\nfragment WidgetIssueOverviewIssueItemContent_issue on Issue {\n  id\n  resolved\n  ...WidgetIssueOverviewIssueItemImageThumbanil_issue\n  ...WidgetIssueOverviewIssueItemTitles_issue\n  ...WidgetIssueOverviewIssueItemAssignees_issue\n  ...WidgetIssueOverviewIssueItemSectionTitle_issue\n}\n\nfragment WidgetIssueOverviewIssueItemImageThumbanil_issue on Issue {\n  images {\n    id\n  }\n}\n\nfragment WidgetIssueOverviewIssueItemSectionTitle_issue on Issue {\n  taskExecution {\n    __typename\n    sectionVersion {\n      title\n      id\n    }\n    id\n  }\n}\n\nfragment WidgetIssueOverviewIssueItemTitles_issue on Issue {\n  task {\n    __typename\n    title\n    id\n  }\n  title\n}\n\nfragment WidgetIssueOverviewIssueItem_issue on Issue {\n  id\n  resolved\n  ...WidgetIssueOverviewIssueItemContent_issue\n}\n\nfragment WidgetIssueOverviewList_issue on Issue {\n  id\n  createdAt\n  task {\n    __typename\n    id\n    title\n    routine {\n      id\n      title\n      ownerTeam {\n        name\n        id\n      }\n    }\n  }\n  taskExecution {\n    __typename\n    id\n    sectionVersion {\n      id\n      ordinal\n      title\n      section {\n        id\n        assignedTeam {\n          id\n          name\n        }\n      }\n    }\n  }\n  ...WidgetIssueOverviewIssueItem_issue\n}\n"
  }
};
})();

(node as any).hash = "1b22c10c15d74bc719d43c7d28856845";

export default node;
